var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"whitespace-no-wrap"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.image)?_c('img',{staticStyle:{"max-height":"1rem"},attrs:{"src":_vm.image,"alt":_vm.label}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }